var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWishlist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.211,
    height: 40.931,
    viewBox: "0 0 36.211 40.931",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13777",
    "data-name": "Group 13777",
    transform: "translate(-905.499 -469.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17432",
    "data-name": "Path 17432",
    d: "M-3350.924-15947.75H-3369.5a1,1,0,0,1-1-1v-26a1,1,0,0,1,1-1h21a1,1,0,0,1,1,1v13.978a4.605,4.605,0,0,0-.9.7l-.89.89-.89-.89a4.588,4.588,0,0,0-3.268-1.354,4.589,4.589,0,0,0-3.268,1.354,4.63,4.63,0,0,0,0,6.535l.89.886,4.9,4.9Z",
    transform: "translate(4277 16456)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-heart",
    "data-name": "Icon feather-heart",
    d: "M18.524,5.851a4.619,4.619,0,0,0-6.534,0l-.89.89-.89-.89a4.62,4.62,0,1,0-6.534,6.534l.89.89L11.1,19.809l6.534-6.534.89-.89a4.619,4.619,0,0,0,0-6.534Z",
    transform: "translate(916.612 490.078)",
    fill: "#fc5692",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17431",
    "data-name": "Path 17431",
    d: "M0,0H3",
    transform: "translate(910 484.75)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17430",
    "data-name": "Path 17430",
    d: "M0,0H3",
    transform: "translate(910 488.75)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17429",
    "data-name": "Path 17429",
    d: "M0,0H3",
    transform: "translate(909.999 492.75)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17428",
    "data-name": "Path 17428",
    d: "M0,0H10",
    transform: "translate(916 484.75)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17427",
    "data-name": "Path 17427",
    d: "M0,0H10",
    transform: "translate(916 488.75)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17426",
    "data-name": "Path 17426",
    d: "M0,0H10",
    transform: "translate(915.999 492.75)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17425",
    "data-name": "Path 17425",
    d: "M0,0V4",
    transform: "matrix(-0.326, 0.946, -0.946, -0.326, 937.663, 484.75)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17424",
    "data-name": "Path 17424",
    d: "M4,0H0",
    transform: "translate(929.197 471.168) rotate(104)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17423",
    "data-name": "Path 17423",
    d: "M0,0,6,5",
    transform: "translate(940.002 473.348) rotate(104)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlist);
export default __webpack_public_path__ + "static/media/wishlist.b5ad6326f800d832d3acf39467fec6c9.svg";
export { ForwardRef as ReactComponent };